<template>
    <div>
        <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-if="name" style="cursor: pointer;" @click.native="handleBack" @click="goback">{{name?name:'首页'}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="cons">
            <div class="acTivitiesDetail">
                <div class="flx">
                    <div class="acImg">
                        <img :src="$img(info.pc_avatar)" alt="" />
                    </div>
                    <div class="acInfo">
                        <div class="acNames flx jsb">
                            <div class="acName" v-text="info.name"></div>
                            <div class="buys flx alc">
                                <div class="buyItem flx alc">
                                    <img :src="$Localimg('deal.png')" alt="" />
                                    <span style="color: #FFBA37;">交易保障</span>
                                </div>
                                <div class="buyItem flx alc">
                                    <i style="font-size: 18px;color: #FF0F23;" class="el-icon-warning-outline"></i>
                                    <span style="color: #FF0F23;">不支持退款</span>
                                </div>
                            </div>
                        </div>

                        <div class="infItem flx alc">
                            <img :src="$Localimg('id1.png')" alt="" />
                            <span v-text="info.time2"></span>
                        </div>

                        <div class="infItem flx alc">
                            <img :src="$Localimg('id2.png')" alt="" />
                            <span v-text="info.address"></span>
                        </div>
                        <div class="infItem flx alc">
                            <img :src="$Localimg('id3.png')" alt="" />
                            <span v-text="`已报名${info.num}人`"></span>
                        </div>
                        <div class="infItem flx" style="margin-bottom: 0 !important;">
                            <img :src="$Localimg('id4.png')" alt="" />
                            <div class="flx tickets" v-if="info.spec.length > 0">
                                <div class="ticketItem cursor flx alc" @click="selTicket(item.id)"
                                    v-for="item,index in info.spec"
                                    :style="ticketId == item.id?'border:1px solid #1677FF' : ''">
                                    <div class="ticketPrice" v-text="`￥${item.money}`"></div>
                                    <div class="ticketName" v-text="item.name"></div>
                                    <img :src="$Localimg('landui.png')" alt="" v-if="ticketId == item.id" />
                                </div>
                            </div>
                            <div class="freePart" v-else
                                v-text="info.default_price * 1 == 0?'免费': '￥'+info.default_price "></div>
                        </div>
                    </div>
                </div>
                <div class="btns flx alc">
                    <div class="btnLeft cursor" v-if="info.pay_status == 0 && info.btn_status == 1" @click="toSign">
                        马上报名
                    </div>
                    <div class="btnLeft cursor" style="background:#999" v-if="info.btn_status == 2">
                        报名已结束
                    </div>
                    <div class="btnLeft cursor" style="background:#999" v-if="info.btn_status == 3">
                        活动已结束
                    </div>
                    <div class="btnLeft cursor" v-if="info.btn_status == 1 && info.pay_status == 1">
                        已报名
                    </div>
                    <div class="btnRight cursor flx alc" @click="colThis">
                        <i class="el-icon-star-off" v-if="info.collect_status == 0"></i>
                        <i class="el-icon-star-on" v-else></i>
                        <span v-text="info.collect_status == 0?'收藏' : '已收藏'"></span>
                    </div>
                </div>
            </div>

            <div class="actips flx jsb">
                <div class="tipLeft">
                    <div class="buytip" v-html="rules"></div>
                    <div class="acintro">
                        <div class="accompany cursor" @click="toCompany">
                            <div class="actitles">
                                <div class="actName">
                                    主办方介绍
                                </div>
                                <div class="bheng"></div>
                            </div>

                            <div class="compart">
                                <div class="comTop flx">
                                    <div class="comImg">
                                        <img :src="$img(info.shop_avatar)" alt="" />
                                    </div>
                                    <div class="cominfo flx jsb">
                                        <div>
                                            <div class="comTitle" v-text="info.shop_name"></div>
                                            <img :src="$Localimg('confirm.png')" alt="" />
                                        </div>
                                        <div class="acfocus cursor" v-if="info.shop_follow_status == 1"
                                            @click.stop="focusThis">
                                            已关注
                                        </div>
                                        <div class="unfocus cursor" v-else @click.stop="focusThis">
                                            +关注主办方
                                        </div>
                                    </div>
                                </div>
                                <div class="comDes multy2" v-text="info.shop_intro"></div>
                            </div>
                        </div>

                        <div class="courseDes">
                            <div class="actitles">
                                <div class="actName">
                                    活动介绍
                                </div>
                                <div class="bheng"></div>
                            </div>
                            <div class="acD" v-html="info.content">

                            </div>
                        </div>

                    </div>
                </div>
                <div class="tipRight">
                    <asideAc></asideAc>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        getActivitiesDetails,
        getRules,
        collectAcs,
        focusCom,
        collectac,

    } from "@/api/index.js"
    import asideAc from "@/components/asidAc.vue"
    export default {
        components: {
            asideAc
        },
        data() {
            return {
                cateName: '',
                id: '',
                page: 1,
                bannerList: [],
                recommand: [],
                totals: 0,
                info: {},
                rules: "",
                ticketId: "",
                channel_id: '',
                name: ""
            }
        },
        created() {
            this.id = this.$route.query.id
            this.name = this.$route.query.name
            if (this.$route.query.channel_id) {
                this.channel_id = this.$route.query.channel_id
            } else {
                this.channel_id = ''
            }
            this.getDetail()
            getRules(11).then((res) => {
                console.log("page", res)
                if (res.code == 1) {
                    this.rules = res.data.content
                }
            })
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.id = to.query.id
                    this.getDetail()
                },
                deep: true
            }
        },
        methods: {
            handleBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.push('/')
                }
            },
            goback() {
                this.$router.go(-1)
            },
            toCompany() {
                let that = this
                that.$router.push({
                    path: '/companyIntro', // 写路由path
                    query: {
                        id: that.info.shop_id,
                        aid: that.id
                    }
                })
            },
            toSign() {
                let that = this
                that.$router.push({
                    path: '/signup', // 写路由path
                    query: {
                        id: that.id,
                        spec_id: that.ticketId,
                        channel_id: that.channel_id
                    }
                })
            },
            selTicket(e) {
                this.ticketId = e
            },
            focusThis() {
                let that = this
                let data = {}
                data.company_id = that.info.company_id
                focusCom(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            colThis() {
                let that = this
                let data = {}
                data.id = that.id
                collectAcs(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getDetail() {
                let that = this
                let data = that.id
                getActivitiesDetails(data).then((res) => {
                    console.log("res", res)
                    if (res.code == 1) {
                        that.info = res.data
                        if (res.data.spec.length > 0) {
                            that.ticketId = res.data.spec[0].id
                        }
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    ::v-deep .acD img {
        max-width: 100% !important;
        height: auto !important;
        display: block;
        /* 消除图片下方空白缝隙 */
    }

    .tickets {
        flex-wrap: wrap;
        width: 500px;
    }

    .ticketPrice {
        font-weight: 500;
        font-size: 16px;
        color: #FF0F23;
        margin-right: 6px;
    }

    .ticketName {
        font-size: 12px;
        color: #666666;
    }

    .ticketItem img {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-right: 0 !important;
    }

    .ticketItem {
        margin-bottom: 20px;
        height: 42px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-right: 14px;
        position: relative;
        flex-shrink: 0;
    }

    .courseDes {
        margin-top: 40px;
    }

    .comDes {
        font-size: 14px;
        color: #6D6D6D;
        margin-top: 12px;
    }

    .acfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(64, 150, 255, 1);
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        color: #007AFF;
        font-weight: 500;
    }

    .unfocus {
        padding: 4px 10px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 14px;
        background: #007AFF;
        font-weight: 500;
    }

    .cominfo {
        flex: 1;
    }

    .cominfo img {
        width: 14px;
        height: 14px;
    }

    .comTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .comImg {
        width: 100px;
        height: 100px;
        margin-right: 12px;
    }

    .comImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        margin-right: 12px;
        object-fit: contain;
    }

    .compart {
        width: 100%;
        background: #F7F8F9;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 20px;

    }

    .bheng {
        width: 24px;
        height: 4px;
        background: #007AFF;
        margin: 0 auto;
        margin-top: 8px;
    }

    .actitles {
        display: inline-block;
        position: relative;
        margin-bottom: 20px;
    }

    .actName {
        font-weight: 500;
        font-size: 18px;
        color: #3C464F;

    }

    .acintro {
        background-color: #fff;
        margin-top: 16px;
        box-sizing: border-box;
        padding: 26px;
        text-align: left;
    }

    .tipLeft {
        width: 1106px;

    }

    .buytip {
        text-align: left;
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }

    .actips {
        margin-top: 16px;
    }

    .btns {
        margin-top: 26px;
        box-sizing: border-box;
        padding-left: 396px;
    }

    .btnRight i {
        margin-right: 6px;
    }

    .btnRight {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        font-weight: 600;
        font-size: 14px;
        color: #007AFF;
    }

    .btnLeft {
        width: 190px;
        height: 40px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 14px;
    }

    .freePart {
        width: 48px;
        height: 26px;
        background: #EFF6FF;
        border-radius: 13px;
        font-size: 12px;
        color: #1E40AF;
        text-align: center;
        line-height: 26px;
    }

    .acNames {
        margin-bottom: 22px;
    }

    .infItem span {
        font-size: 14px;
        color: #1F2937;
    }

    .infItem {
        margin-bottom: 16px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .buyItem {
        font-size: 14px;
        margin-left: 18px;
    }

    .buyItem img {
        width: 20px;
        height: 20px;
    }

    .buyItem span {
        margin-left: 4px;
    }

    .acName {
        font-weight: 600;
        font-size: 18px;
    }

    .acInfo {
        flex: 1;
    }

    .acImg {
        width: 344px;
        height: 194px;
        margin-right: 20px;
    }

    .acImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .acTivitiesDetail {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 26px;
    }

    .cons {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0;
        border-radius: 10px;
    }
</style>